.#{$namespace}-overlay {
	position: fixed;
	inset: 0;
	overflow: auto;
	z-index: 2000;

	&.is-mask {
		background-color: shade-color($black-color, 50%);
	}

	// Dialog / MessageBox 都挂在 overlay 上；放这里按需引 overlay 就能居中，写进 dialog 时 MessageBox 打包后会丢
	&.is-align-center {
		display: flex;
		align-items: center;
		justify-content: center;
	}
}

.#{$namespace}-overlay-fade-enter-active,
.#{$namespace}-overlay-fade-leave-active {
	transition: opacity 0.3s;
}

.#{$namespace}-overlay-fade-enter-from,
.#{$namespace}-overlay-fade-leave-to {
	opacity: 0;
}
